

  import {defineComponent} from "vue";
  import {Link} from "@/domain/ui/Link";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: 'sub-navigator',
    props: ['navigatorCode'],
    data() {
      return {
        links: [
          new Link(new NamedRouting('MyUsableTicketView'), "보유 선물", "usableTicket"),
          new Link(new NamedRouting('MyUnusableTicketView'), "지난 선물", "unusableTicket"),
          new Link(new NamedRouting('MyOrderView'), "구매 내역", "myOrder")
        ],
      }
    },
    methods: {
      activated(link: Link): string {
        if (link.code === this.navigatorCode) {
          return "is_active";
        } else {
          return "";
        }
      }
    },
  });

